// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; 


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDx-UB5ImP7Mo1DJcrmT0vQwpr4yFhE1j8",
  authDomain: "dachou-nazo-website.firebaseapp.com",
  projectId: "dachou-nazo-website",
  storageBucket: "dachou-nazo-website.firebasestorage.app",
  messagingSenderId: "372085809252",
  appId: "1:372085809252:web:59295289044d04af1a3f71",
  measurementId: "G-8RT4XNDZ7Y",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);